import { TrackEventType } from '../auth';
import { CustomAttributeFilterItem } from '../customers/model';

export enum ListInputItemOptions {
  campaignStatus = 'Campaign Status',
  dispatchStatus = 'Dispatch Status',
  tags = 'Tags',
  customers = 'Customers',
  campaignCustomers = ' Customers',
  ProductSegments = 'Product Segments',
  status = 'status',
  priceListStatus = 'Status  ',
  routes = 'Routes',
  products = 'products',
  teamMembers = 'teamMembers',
  threadTeamMembers = 'Team Members',
  schemeActiveStatus = 'Status     ',
  schemeType = 'Scheme Type',
  slab = 'Slab',
  divisions = 'Divisions',
  headDivision = 'Head Divisions',
  cities = 'Cities',
  criteria = 'Criteria',
  distributors = 'Distributors',
  outstandingTransactionType = 'OutstandingTransactionType',
  multiMapping = 'Multi Mapping',
  modifiedQty = 'Modified Quantity',
  teamMemberType = 'Type ',
  importSource = 'Order Import Source',
  poImportSource = 'Order Imported From',
  view = 'View',
  alphabets = 'By Alphabets',
  poOrderStatus = 'Order Status  ',
  paymentStatus = 'Payment Status',
  paymentMode = 'Payment Mode',
  paymentType = 'Payment Type',
  orderNumber = 'Order Number',
  cfaPrincipalCustomers = 'Customers  ',
  segmentRoutes = 'Routes ',
  //  Bulk Import
  bulkImportTaskStatus = 'Task Status',
  bulkImportEntityType = 'Task Type',
  activeStatus = 'Status ',
  cfaStatus = 'Status',
  cfaType = 'Type',
  states = 'States',
  groups = 'Groups',
  customerLifeCycleGroups = 'Lifecycle',
  customerStatus = 'Status   ',
  onboardingStatus = 'Onboarding Status',
  collections = 'Category',
  cfaInventory = 'CFA Inventory',
  stockLevel = 'Stock Level',
  cfa = 'CFAs',
  salesCfa = 'CFAs ',
  orderStatus = 'Order Status',
  invoice = 'Invoice',
  scheme = 'Scheme',
  cfaCustomers = 'Customers ',
  returnStatus = 'Order Status ',
  returnType = 'Order Type',
  importSources = 'Import Sources',
  batchNumbers = 'Batch Numbers',
  batchCategory = 'Return Category',
  returnLineStatus = 'Return Line Status',
  ledgerTransactionType = 'Transaction Type',
  turnoverLedgerTransactionType = 'Transaction Type ',
  invoiceStatus = 'Invoice Status',
  categories = 'Categories',
  threadActionsTags = 'Tags ',
  issueType = 'Issue Type',
  issueThreadStatus = 'Issue Status',
  principal = 'Principal',
  ledgerAmount = 'Amount',
  adminImportSource = 'Import Source',
  mappingStatus = 'Mapping Status',
  adminOrderStatus = 'Orders Status',
  Ztag = 'Order Tags',
  cfaReports = 'CFAs  ',
  erpCustomerName = 'Customer Firm Name',
  erpMappingStatus = 'Sync Status',
  erpTransactionType = ' Transaction Type',
  erpTaskStatus = 'Task Status',
  threadCfa = "CFA's",
  threadStatus = 'Status   ',
  threadDivision = 'Divisions ',
  dueDate = 'Due Date',
  dispatchDate = 'Dispatch Date',
  messageStatus = ' Status',
  customerSegments = 'Customer Segments',
  segment = 'segment',
  segments = 'segments',
  promotionsbyStatus = 'By Status',
  promotionsbyMode = 'By Mode',
  promotionsbyType = 'By Type',
  TemplateStatus = 'Template Status',
  Language = 'Language',
  TemplateCategory = 'Template Category',
  TemplateTag = 'Template Tag',
  sourceFilter = 'Order Source',
  userType = 'User Type',
  pinCode = 'Pin Code',
  district = 'District',
  salesmen = 'Salesmen',
  fulfillments = 'Fulfillments',
  formType = 'Type',
  formStatus = 'Status',
  formCustomers = 'Customer',
  state = 'States',
  pincode = 'Pin Code',
  category = 'Categories',
  division = 'Divisions',
  refOrderNumber = 'Order Number',
  dynamicSegments = 'Dynamic Segments',
  imagePreview = 'Image Preview',
  audienceType = 'Audience Type',
  adSource = 'adSource',
  botTypeList = 'Bot Name',
  accountStatus = 'Account Status',
  pendingInvoiceStatus = 'Pending Invoice Status',
  turnoverInvoiceStatus = 'Status    ',
  turnoverInvoiceValidationStatus = 'Validation Status',
  turnoverInvoiceSeller = 'Distributor / CFA',
  turnoverInvoiceBuyer = 'Buyer',
  turnoverInvoiceLineItemStatus = 'Line Item Status',
  turnoverInvoiceLineValidationFields = 'Parsing Status',
  turnoverCustomerAppliedScheme = 'Applied Scheme',
  teamMemberRole = 'Role',
  dashboardProductFilter = 'dashboardProductFilter',
  dashboardCustomerFilter = 'dashboardCustomerFilter',
  productNames = 'Products',
}
export const TURNOVER_INVOICE_LINE_VALIDATION_FIELD_OPTIONS: ReadonlyArray<{
  id: string;
  value: string;
}> = [
  { id: 'UNIT_PRICE_NOT_FOUND', value: 'Unit Price Not Found ' },
  { id: 'SKU_NOT_FOUND', value: 'SKU Not Found' },
  { id: 'PRODUCT_NOT_FOUND', value: 'Product Name Not Found' },
  { id: 'HSN_NOT_FOUND', value: 'HSN Code Not Found' },
  { id: 'QUANTITY_NOT_FOUND', value: 'Product Quantity Not Found' },
  { id: 'UNIT_NOT_FOUND', value: 'Product Unit Not Found' },
  { id: 'LINE_TOTAL_NOT_FOUND', value: 'Line Total Not Found' },
  { id: 'TAX_AMOUNT_NOT_FOUND', value: 'Tax Details Not Found' },
];

export enum TreeInputItemOptions {
  threadRoutes = 'Routes',
  threadSegments = 'Segments',
  threadCustomerLifeCycleGroups = 'Lifecycle',
  threadDynamicSegments = 'Dynamic Segments',
}

export enum ListInputItemOptionsWithSearch {
  customers = 'Customers',
  dynamicSegments = 'Dynamic Segments',
  routes = 'Routes',
  segments = 'Segments',
}

export enum StringInputItemOptions {
  paymentId = 'paymentId',
  skuCode = 'SKU Code',
  botName = 'Bot Name',
  customerCode = 'Customer Code',
  mobileNumber = 'Mobile Number',
  composition = 'Composition',
  sellerName = 'Seller Name',
}

export enum BooleanInputItemOptions {
  PendingPayment = 'Include Pending Payment',
  UnreadMessages = 'Unread',
}

export enum ArithmeticOperatorInputOptions {
  outstandingPayment = 'outstandingPayment',
  pendingPayment = 'pendingPayment',
  paidAmount = 'paidAmount',
  receivedAmount = 'receivedAmount',
  currentStock = 'current_stock',
  inventoryValue = 'inventory_value',
  totalRevenue = 'total_revenue',
}

export enum Operator {
  less_than = 'lt',
  equal_to = 'eq',
  greater_than = 'gt',
  greater_than_equal = 'gte',
  less_than_equal = 'lte',
  not_equal = 'neq',
}

export interface FilterInputs {
  arithmeticOperatorInputItem?: ArithmeticOperatorInputItem;
  booleanInputItem?: BooleanInputItem;
  listInputItem?: ListInputItem;
  searchListInputItem?: SearchListInputItem;
  stringInputItem?: StringInputItem;
  calendarInputItem?: CalendarInputItem;
  sortField: SortField;
  treeInputItem?: TreeInputItem;
  listInputItemWithSearch?: ListInputItemWithSearch;
  /** Applied custom attribute filters (customer screen Custom Fields tab) */
  customAttributeFilter?: CustomAttributeFilterItem[];
}

export type ListInputItemWithSearch = {
  [key in ListInputItemOptionsWithSearch]: InputItem[];
};
export type ListInputItem = {
  [key in ListInputItemOptions]: InputItem[];
};

export type TreeInputItem = {
  [key in TreeInputItemOptions]: TreeInput[];
};

export type SearchListInputItem = {
  [key in ListInputItemOptions]: {
    listInputItem: InputItem[];
    searchTerm: string;
  };
};

export type StringInputItem = {
  [key in StringInputItemOptions]: string;
};
export type ArithmeticOperatorInputItem = {
  [key in ArithmeticOperatorInputOptions]: ArithmeticOperator;
};

export type BooleanInputItem = {
  [key in BooleanInputItemOptions]: boolean;
};

export type CalendarInputItem = {
  [key: string]: string;
};

export interface InputItem {
  TreeData?: any;
  id: string;
  value: string;
  selected: boolean;
  eitherOr?: boolean;
  isDefault?: boolean;
  eventType?: TrackEventType;
}

export interface TreeInput {
  TreeData: TreeInput[];
  id: string;
  selected: boolean;
  value: string;
}

export interface ArithmeticOperator {
  operator: Operator;
  value: number;
}

export enum SortDirection {
  ASCENDING = 'ASC',
  DESCENDING = 'DESC',
}

export interface SortField {
  field: string;
  direction: SortDirection;
}

export interface ImageSearchKey {
  path: string;
  type: string;
  width?: number;
  height?: number;
}

export enum RecentSearchTypes {
  PRODUCTS = 'products',
  SCHEMES = 'schemes',
  ORDERS = 'orders',
  TRACKPOS = 'trackPos',
  CART = 'cart',
  RETURNS = 'returns',
  LEDGER = 'ledger',
  Invoice = 'invoice',
  CUTOMERS = 'customers',
  THREADS = 'threads',
  FORWARD = 'forward',
  TAGS = 'tags',
  PAYMENT = 'payment',
  MEMBERS = 'members',
  CAMPAIGNS = 'campaigns',
}

export enum EpochScreenType {
  REPORT = 'REPORT',
  ORDERLIST = 'ORDER LIST',
  INVOICELIST = 'INVOICE LIST',
  SEGMENT_LIST = 'SEGMENT_LIST',
  BEAT_PLANS = 'BEAT_PLANS',
  SALES_TEAM_ACTIVITY = 'SALES TEAM ACTIVITY',
  CAMPAIGN_DETAIL = 'CAMPAIGN DETAIL',
  CAMPAIGN_LIST = 'CAMPAIGN_LIST',
  SEND_CAMPAIGN = 'SEND_CAMPAIGN',
  CAMPAIGN_REVENUE = 'CAMPAIGN_REVENUE',
  REVENUE_BREAKDOWN = 'REVENUE_BREAKDOWN',
  CAMPAIGN_DAY_WISE = 'CAMPAIGN_DAY_WISE',
  CUSTOMERS_ERP_SYNC_DETAILS = 'CUSTOMERS_ERP_SYNC_DETAILS',
  HOME = 'HOME',
  CREATE_BEAT_PLAN = 'CREATE_BEAT_PLAN',
  PAYMENTS_SCREEN = 'PAYMENTS_SCREEN',
  CONSUMPTION_METRICS = 'CONSUMPTION_METRICS',
  GROW_CONVERSATION_LIST = 'GROW_CONVERSATION_LIST',
  CUSTOMER_CONTACT_SELECTION = 'CUSTOMER_CONTACT_SELECTION',
  SALES_DASHBOARD = 'SALES_DASHBOARD',
}

export interface Epoch {
  [key: string]: {
    startDate: Date;
    endDate: Date;
  };
}

export enum SiftScreenEnum {
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  PRODUCT_PERFORMANCE_REPORTS = 'PRODUCT_PERFORMANCE_REPORTS',
  CUSTOMER_PERFORMANCE_REPORTS = 'CUSTOMER_PERFORMANCE_REPORTS',
  INVOICE_REPORTS = 'INVOICE_REPORTS',
  CAMPAIGN_CUSTOMER_REPORTS = 'CAMPAIGN_CUSTOMER_REPORTS',
  ORDER_DETAILS_REPORT = 'ORDER_DETAILS_REPORT',
  SALES_TEAM_CHECKINS_REPORT = 'SALES_TEAM_CHECKINS_REPORT',
  PAYMENTS_REPORT = 'PAYMENTS_REPORT',
  SUPPLY_TRACKER = 'SUPPLY_TRACKER',
  SALES_LEADERBOARD_REPORT = 'SALES_LEADERBOARD_REPORT',
  SALES_CLOCKIN_REPORT = 'SALES_CLOCKIN_REPORT',
  CAMPAIGN_LIST_SCREEN = 'CAMPAIGN_LIST_SCREEN',
  SEND_CAMPAIGN_SCREEN = 'SEND_CAMPAIGN_SCREEN',
  CUSTOMER_SCREEN = 'CUSTOMER_SCREEN',
  SEGMENTS_SCREEN = 'SEGMENTS_SCREEN',
  GROUPS_SCREEN = 'GROUPS_SCREEN',
  SEGMENTS_DETAILS_SCREEN = 'SEGMENTS_DETAILS_SCREEN',
  PRODUCTS_SCREEN = 'PRODUCTS_SCREEN',
  DYNAMIC_SEGMENT_SCREEN = 'DYNAMIC_SEGMENT_SCREEN',
  ORDER_LINE_SCREEN = 'ORDER_LINE_SCREEN',
  CUSTOMERS_ERP_SYNC_DETAILS = 'CUSTOMERS_ERP_SYNC_DETAILS',
  PAYMENTS_SCREEN = 'PAYMENTS_SCREEN',
  SCHEMES_SCREEN = 'SCHEMES_SCREEN',
  DYNAMIC_SEGMENTS_REPORTS = 'DYNAMIC_SEGMENTS_REPORTS',
  DYNAMIC_SEGMENTS_REPORTS_DETAILS = 'DYNAMIC_SEGMENTS_REPORTS_DETAILS',
  BEAT_PLANS_SCREEN = 'BEAT_PLANS_SCREEN',
  CAMPAIGN_ATTEMPTS = 'CAMPAIGN_ATTEMPTS',
  TYPEBOT_USER_RESPONSES = 'TYPEBOT_USER_RESPONSES',
  PRICE_LIST_SCREEN = 'PRICE_LIST_SCREEN',
  SEARCH_SELECT_PRODCUTS = 'SEARCH_SELECT_PRODUCTS',
  PRINCIPAL_ORDER_SCREEN = 'PRINCIPAL_ORDER_SCREEN',
  PRINCIPAL_INVOICE_SCREEN = 'PRINCIPAL_INVOICE_SCREEN',
  TURNOVER_CUSTOMERS = 'TURNOVER_CUSTOMERS',
  TURNOVER_SCHEMES = 'TURNOVER_SCHEMES',
  TURNOVER_SCHEME_DETAILS = 'TURNOVER_SCHEME_DETAILS',
  TURNOVER_CUSTOMER_DETAILS = 'TURNOVER_CUSTOMER_DETAILS',
  TURNOVER_INVOICE_DETAILS = 'TURNOVER_INVOICE_DETAILS',
  TURNOVER_PENDING_INVOICES = 'TURNOVER_PENDING_INVOICES',
  CUSTOEMER_CONTACT_SELECTION = 'CUSTOEMER_CONTACT_SELECTION',
  TURNOVER_SCHEME_REPORT = 'TURNOVER_SCHEME_REPORT',
  CFA_SCREEN = 'CFA_SCREEN',
  TEAM_INVITES_SCREEN = 'TEAM_INVITES_SCREEN',
  SALES_TEAM_SCREEN = 'SALES_TEAM_SCREEN',
  WHATSAPP_TEMPLATES = 'WHATSAPP_TEMPLATES',
  SALES_DASHBOARD = 'SALES_DASHBOARD',
}

type SiftScreenValueType = {
  [key: string]: any;
};

export type Sift = {
  [K in SiftScreenEnum]: SiftScreenValueType | undefined;
} & {
  [SiftScreenEnum.APPLIED_FILTERS]: SiftScreenValueType;
};

export interface RecentSearchData {
  products: string[];
  schemes: string[];
  orders: string[];
  trackPos: string[];
  cart: string[];
  returns: string[];
  ledger: string[];
  invoice: string[];
  threads: string[];
  customers: string[];
  tags: string[];
  payment: string[];
  members: string[];
  campaigns: string[];
}

// Mobile Filters
export enum MobileSiftScreen {
  CUSTOMER_THREADS = 'CustomerThreads',
  ISSUE_THREADS = 'IssueThreads',
  ORDERS = 'Orders',
  INVOICES = 'Invoices',
  PAYMENTS = 'Payments',
  CAMPAIGNS = 'Campaigns',
  DISPATCH = 'Dispatch',
  LEDGER = 'Ledger',
  PRODUCTS = 'Products',
  SCHEMES = 'Schemes',
  CAMPAIGN_TEMPLATES = 'Campaign Templates',
  CAMPAIGN_CUSTOMERS = 'Campaign Customers',
  CUSTOMERS = 'Customers',
  DAYBOOK = 'Daybook',
  CONVERSATIONS = 'Conversations',
  CAMPAIGN_CUSTOMERS_STATS = 'Campaign Customers Stats',
  CAMPAIGN_PRODUCTS = 'Campaign Products',
}

export enum BooleanFilterKeys {
  UnreadMessages = 'Unread',
}

export enum ListFilterKeys {
  Cfa = 'CFAs',
  TeamMembers = 'Team Members',
  Divisions = 'Divisions',
  Customers = 'Customers',
  IssueType = 'Issue Type',
  OrderStatus = 'Order Status',
  OrderTags = 'Order Tags',
  ImportSource = 'Import Source',
  OrderSource = 'Order Source',
  InvoiceStatus = 'Invoice Status',
  PaymentStatus = 'Payment Status',
  CampaignByStatus = 'By Status',
  CampaignMode = 'By Mode',
  CampaignType = 'By Type',
  LedgerTransaction = 'Ledger Transaction',
  SchemeType = 'Scheme Type',
  TemplateType = 'Template Type',
  CampaignMetrics = 'Campaign Metrics',
  CustomerStatus = 'Customer Status',
  OnboardingStatus = 'Onboarding Status',
  SchemeStatus = 'Scheme Status',
  Status = 'Status',
  PaymentMode = 'Payment Mode',
  PaymentType = 'Payment Type',
  DispatchStatus = 'Dispatch Status',
  ConversationStatus = 'Conversation Status',
  ThreadStatus = 'Thread Status',
  CampaignStatus = 'Campaign Status',
  Category = 'Category',
  Division = 'Division',
}

export enum SectionFilterKeys {
  Status = 'Status',
  Other = 'Other',
}

export enum TreeFilterKeys {
  Routes = 'Routes',
  Segments = 'Segments',
  Categories = 'Categories',
  ProductStatus = 'Product Status',
  DynamicSegments = 'Dynamic Segments',
  CustomerLifeCycle = 'Customer Life Cycle',
}

export type BooleanFilterInput = {
  [k in BooleanFilterKeys]: boolean;
};

export interface ListFilterItem {
  multiSelect: boolean;
  value: InputItem[];
}

export type ListFilterInput = {
  [k in ListFilterKeys]: ListFilterItem;
};

export interface SectionInputItem {
  title: string;
  data: InputItem[];
}

export interface SectionFilterInputItem {
  multiSelect: boolean;
  value: SectionInputItem[];
}

export type SectionFilterInput = {
  [k in SectionFilterKeys]: SectionFilterInputItem;
};

export interface TreeInputData extends InputItem {
  data?: TreeInputData[];
}

export interface TreeFilterInputItem {
  applyParent: boolean;
  value: TreeInputData[];
}

export type TreeFilterInput = {
  [k in TreeFilterKeys]: TreeFilterInputItem;
};

export interface SortFilterItem {
  field: string;
  display: Record<SortDirection, string>;
  isDefault?: SortDirection;
  selected: SortDirection | false;
}

export type SortFilterInput = {
  [k: string]: SortFilterItem;
};

export interface DateRangeItem {
  startDate: Date;
  endDate: Date;
}

export interface DateRangeFilterItem extends DateRangeItem {
  defaultRange?: DateRangeItem;
}

export interface FiltersData {
  booleanFilter?: Partial<BooleanFilterInput>;
  listFilter?: Partial<ListFilterInput>;
  sectionFilter?: Partial<SectionFilterInput>;
  treeFilter?: Partial<TreeFilterInput>;
  sortFilter?: SortFilterInput;
  dateRange?: DateRangeFilterItem;
}

export interface ListAppliedItem {
  id: string;
  value: string;
}

export type AppliedListFilterItem = {
  [k in ListFilterKeys]: ListAppliedItem[];
};

export interface SectionAppliedItem extends ListAppliedItem {
  section: string;
}

export type AppliedSectionFilterItem = {
  [k in SectionFilterKeys]: SectionAppliedItem[];
};

export type AppliedTreeFilterItem = {
  [k in TreeFilterKeys]: ListAppliedItem[];
};

export interface AppliedDateRangeItem extends DateRangeItem {
  isDefault: boolean;
}

export interface AppliedFiltersData {
  booleanFilter?: BooleanFilterKeys[];
  listFilter?: Partial<AppliedListFilterItem>;
  sectionFilter?: Partial<AppliedSectionFilterItem>;
  treeFilter?: Partial<AppliedTreeFilterItem>;
  sortFilter?: SortField;
  dateRange?: AppliedDateRangeItem;
}

export type MobileSift = {
  [k in MobileSiftScreen]?: {
    loading: boolean;
    filters: FiltersData;
  };
};

export type MobileSiftApplied = {
  [k in MobileSiftScreen]?: AppliedFiltersData;
};

export type MobileSearch = {
  [k in MobileSiftScreen]?: MobileSearchValue;
};

export type MobileSearchValue = {
  active: boolean;
  searchKey: string;
};

export interface Mappings<T> {
  dataKey: keyof T;
  idKey: string;
  valueKey: string;
  filterKey: ListFilterKeys;
  multiSelect?: boolean;
  updateValues?: boolean;
  appliedFilterIds?: string[];
}
